
import { AgeTagType, FontItem, SurveyCsvData } from "@/store/types";
import { Options, Vue } from "vue-class-component";
import { namespace } from "vuex-class";
import router from "@/router";
import { RTWebFontAPI } from "@/utils/realtype-web-font";

declare global {
  interface Window {
    RT: RTWebFontAPI;
  }
}

const SystemModule = namespace("system");
const SurveyModule = namespace("survey");
@Options({
  components: {},
  beforeRouteEnter: (to, from, next) => {
    if (from.fullPath !== "/survey/writing-care") {
      router.replace("/survey/entrance");
    } else {
      next();
    }
  },
})
export default class SurveyFreeComment extends Vue {
  public freeComment = "";

  @SurveyModule.Getter("byAgeTag")
  private byAgeTag!: AgeTagType;

  @SurveyModule.Action("updateSurveyFreeComment")
  private updateSurveyFreeComment!: (freeComment: string) => Promise<void>;

  @SurveyModule.Getter("surveyData")
  private surveyData!: SurveyCsvData;

  @SurveyModule.Getter("isWhiteout")
  private isWhiteout!: boolean;

  @SystemModule.Getter("getFontList")
  private getFontList!: FontItem[];

  @SurveyModule.Action("updateIsWhiteout")
  private updateIsWhiteout!: (isWhiteout: boolean) => Promise<void>;

  public isVisible = false;

  public async mounted(): Promise<void> {
    await this.updateIsWhiteout(false);
    window.scrollTo({ top: 0 });
    this.isVisible = true;
  }

  public get isHiraganaWord() {
    return this.byAgeTag === "UNDER_10";
  }

  private get selectedFontFaimlyClassName(): string {
    let fontFamilyClassName = "";

    const fontItem = this.getFontList.find(
      (item) => item.id === this.surveyData.font
    );
    if (fontItem) {
      fontFamilyClassName = fontItem.tag;
    }
    return fontFamilyClassName;
  }

  public async nextPage(): Promise<void> {
    await this.updateSurveyFreeComment(this.freeComment);
    await this.updateIsWhiteout(true);
    this.$router.push("/survey/exit");
  }

  public get titleWord(): string {
    let word =
      "文字を読むときに、困っていることや工夫していることがあったら教えてください。";
    if (this.isHiraganaWord) {
      word =
        "もじを よむときに、こまっていることや くふうしていることを、おしえてください。";
    }
    return word;
  }

  public get nextPageButtonWord(): string {
    let word = "次の画面へ進む";
    if (this.isHiraganaWord) {
      word = "つぎの がめんへ すすむ";
    }
    return word;
  }
}
